<template>
    <div>{{ digikalaAuthStatus }}</div>
</template>
<script>
export default {
  data () {
    return {
      digikalaAuthStatus: false
    }
  },
  mounted () {
    /* console.log(this.$route.query.status) */
    this.digikalaAuthStatus = this.$route.query.status
    /* if (!localStorage.getItem('digikalaAuth')) {
      localStorage.setItem('digikalaAuth', this.$route.query.status)
    } */
  }
}
</script>
